import React, { Component } from "react";
import _ from "lodash";
import OfflineMvrReportTable from "./OfflineMvrReportTable";

class OfflineDriversLicenseSearches extends Component {
  componentDidMount() {}

  render() {
    const crimRequestDilRecs = _.get(
      this.props.data,
      "offline.offlineMVR[0].crimRequestDil",
      []
    );

    const ordOrimRequestDilRecs = _.orderBy(crimRequestDilRecs, o =>
      _.get(o, "crimRequest[0].crimStatus[0]")
    );
    return (
      <OfflineMvrReportTable {...this.props} recs={ordOrimRequestDilRecs} />
    );
  }
}

export default OfflineDriversLicenseSearches;



// WEBPACK FOOTER //
// ./src/components/myaccount/OfflineDriversLicenseSearches.js